import { render } from "./IntercomsList.vue?vue&type=template&id=32914cc5&scoped=true"
import script from "./IntercomsList.vue?vue&type=script&lang=js"
export * from "./IntercomsList.vue?vue&type=script&lang=js"

import "./IntercomsList.vue?vue&type=style&index=0&id=32914cc5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32914cc5"]])

export default __exports__